import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type IMyStripePayemntResponse } from "./types";

const initialState: IMyStripePayemntResponse = {
  clientSecret: null,
  paymentIntentId: null,
};

const myStripePaymentSlice = createSlice({
  name: "stripePaymentResponse",
  initialState,
  reducers: {
    setMyStripePaymentData: (
      state,
      action: PayloadAction<IMyStripePayemntResponse>,
    ) => {
      state.clientSecret = action.payload.clientSecret;
      state.paymentIntentId = action.payload.paymentIntentId;
    },
    clearMyStripePaymentData: (state) => {
      state.clientSecret = null;
      state.paymentIntentId = null;
    },
  },
});

// Export actions
export const { setMyStripePaymentData, clearMyStripePaymentData } =
  myStripePaymentSlice.actions;
export default myStripePaymentSlice.reducer;
